import { NavigationEnd, Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { DynamicFormGroupService } from 'src/app/services/dynamic-form-group.service';

@Component({
  selector: 'calsoft-price-table-plan6',
  templateUrl: './price-table-plan6.component.html',
  styleUrls: ['./price-table-plan6.component.scss']
})
export class PriceTablePlan6Component implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  priceForm: FormGroup;
  formData: any;
  btntext: string;

  @Output() setData6 = new EventEmitter<any>();
  @Input() priceplandata6: any;

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private dynamicFormGroupService: DynamicFormGroupService
  , private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
}

  ngOnInit() {
    this.createForm();
    this.populateForm();
    this.getdynamicFormList();
    this.dynmaicFormYFilter();
  }

  createForm() {
    this.priceForm = this.fb.group({
      free_charge_year: [''],
      std_charge_year: [''],
      pro_charge_year: [''],
      ent_charge_year: [''],
      u_charge_year: [''],

      free_charge_month: [''],
      std_charge_month: [''],
      pro_charge_month: [''],
      ent_charge_month: [''],
      u_charge_month: [''],

      pricedetail: this.fb.array([])
    });

    this.addPricingDetails();
    this.btntext = 'Submit';
  }

  get pricedetail(): FormArray {
    return this.priceForm.get('pricedetail') as FormArray;
  }

  addPricingDetails() {
    this.pricedetail.push(this.fb.group({
      title: '',
      list_detail: this.fb.array([])
    }));
    this.addListDetail(this.pricedetail.length - 1);
  }

  addListDetail(index: number) {
    const listDetail = this.pricedetail.at(index).get('list_detail') as FormArray;
    listDetail.push(this.fb.group({
      free:'',
      sub_title: '',
      starter: '',
      profession: '',
      advanced: '',
      navigation: [1],
      button_name: '',
      button_link: '',
      id_element: '',
      value: '',
      table_color: ''
    }));
  }

  deletePricingDetail(index: number) {
    this.pricedetail.removeAt(index);
  }

  deleteListDetail(detailIndex: number, listIndex: number) {
    const listDetail = this.pricedetail.at(detailIndex).get('list_detail') as FormArray;
    listDetail.removeAt(listIndex);

  }

  populateForm() {
    if (this.priceplandata6) {
      this.priceForm.patchValue({
        free_charge_year: this.priceplandata6.free_charge_year,
        std_charge_year: this.priceplandata6.std_charge_year,
        pro_charge_year: this.priceplandata6.pro_charge_year,
        ent_charge_year: this.priceplandata6.ent_charge_year,
        u_charge_year: this.priceplandata6.u_charge_year,

        free_charge_month: this.priceplandata6.free_charge_month,
        std_charge_month: this.priceplandata6.std_charge_month,
        pro_charge_month: this.priceplandata6.pro_charge_month,
        ent_charge_month: this.priceplandata6.ent_charge_month,
        u_charge_month: this.priceplandata6.u_charge_month
      });

      const pricedetailFormArray = this.priceForm.get('pricedetail') as FormArray;
      pricedetailFormArray.clear();

      this.priceplandata6.pricedetail.forEach((detail: any) => {
        const detailFormGroup = this.fb.group({
          title: detail.title,
          list_detail: this.fb.array([])
        });

        const listDetailFormArray = detailFormGroup.get('list_detail') as FormArray;
        detail.list_detail.forEach((item: any) => {
          listDetailFormArray.push(this.fb.group(item));
        });

        pricedetailFormArray.push(detailFormGroup);
      });

      this.btntext = 'Update';
    }
  }

  onSubmit() {
    const pricingFields = {
      free_charge_year: this.priceForm.value.free_charge_year,
      std_charge_year: this.priceForm.value.std_charge_year,
      pro_charge_year: this.priceForm.value.pro_charge_year,
      ent_charge_year: this.priceForm.value.ent_charge_year,
      u_charge_year: this.priceForm.value.u_charge_year,

      free_charge_month: this.priceForm.value.free_charge_month,
      std_charge_month: this.priceForm.value.std_charge_month,
      pro_charge_month: this.priceForm.value.pro_charge_month,
      ent_charge_month: this.priceForm.value.ent_charge_month,
      u_charge_month: this.priceForm.value.u_charge_month
    };

    const detailItems = this.pricedetail.value.map(detail => ({
      title: detail.title,
      list_detail: detail.list_detail
    }));

    this.formData = {
      ...pricingFields,
      pricedetail: detailItems
    };

    this.emit();
  }

  emit() {
    this.setData6.emit(this.formData);
    console.log(this.formData);
  }

  navigation: any = [
    { viewValue: 'Link', value: 1 },
    { viewValue: 'ID', value: 0 },
    { viewValue: 'Form', value: 2 }
  ];

  protected _onDestroy = new Subject<void>();
  dynamicFormTypeList: any;
  filtereddynamicFormTypeList: any;
  public dynamicFormFilterControl: UntypedFormControl = new UntypedFormControl();

  getdynamicFormList() {
    this.dynamicFormGroupService.getAllDynmaicFormDropDown(1).subscribe(
      (res) => {
        this.dynamicFormTypeList = res;
        this.filtereddynamicFormTypeList = this.dynamicFormTypeList;
      },
      (error) => {}
    );
  }

  dynmaicFormYFilter() {
    this.dynamicFormFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.dynamicFilter();
      });
  }

  protected dynamicFilter() {
    if (!this.dynamicFormTypeList) return;
    let search = this.dynamicFormFilterControl.value;
    if (!search) {
      this.filtereddynamicFormTypeList = this.dynamicFormTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filtereddynamicFormTypeList = this.dynamicFormTypeList.filter((dynamicForm) =>
      dynamicForm['name'].toLowerCase().includes(search)
    );
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
